// src/routes/routeMap.js
// SINGLE SOURCE OF TRUTH for all navigation links
// NO ?id= anywhere - ID only in path

// ==================== PROFIL ====================
export const hodowlaCreate = () => "/panel/profil";
export const hodowlaEdit = (id) => `/panel/profil`;

// ==================== OFERTY ====================
export const miotCreate = () => "/wizard/miot";
export const miotEdit = (id) => `/wizard/miot/${id}`;

export const reproCreate = () => "/wizard/reproduktor";
export const reproEdit = (id) => `/wizard/reproduktor/${id}`;

// ==================== ZASOBY ====================
export const piesEdit = (id) => `/panel/pies/${id}/edytuj`;

// ==================== PANEL PAGES ====================
export const panelHome = () => "/panel";
export const panelMarketing = () => "/panel/marketing";
export const panelLeady = () => "/panel/leady";
export const panelProfil = () => "/panel/profil";
export const panelPsy = () => "/panel/psy";
export const panelKoty = () => "/panel/profil";
export const panelMioty = () => "/panel/mioty";
export const panelStrona = () => "/panel/strona";
export const panelKonto = () => "/panel/ustawienia/konto";
export const panelPlatnosci = () => "/panel/ustawienia/platnosci";
export const panelReproduktory = () => "/panel/profil";
export const panelPomoc = () => "/panel/pomoc";
export const panelGrafiki = () => "/panel/grafiki";

// Legacy aliases (keep for backward compat in existing pages)
export const panelBooster = () => "/panel/booster";
export const panelStatystyki = () => "/panel/statystyki";
export const panelMyPages = () => "/panel/strony";

// Business-specific
export const panelUslugi = () => "/panel/uslugi";
export const panelGaleria = () => "/panel/galeria";

// Alias for editing dogs
export const psyEdit = (id) => `/panel/pies/${id}/edytuj`;
export const reproduktorEdit = (id) => `/wizard/reproduktor/${id}`;

// ==================== PUBLIC PAGES ====================
export const publicHodowla = (slug) => `/hodowla/${slug}`;
export const publicMiot = (slug) => `/miot/${slug}`;
export const publicReproduktor = (slug) => `/reproduktor/${slug}`;
export const publicPies = (slug) => `/pies/${slug}`;

// ==================== HELPER FOR ENTITY ROUTING ====================
export const getEditRoute = (entityType, id) => {
  switch (entityType) {
    case 'kennel':
    case 'hodowla':
      return hodowlaEdit(id);
    case 'litter':
    case 'miot':
      return miotEdit(id);
    case 'stud':
    case 'reproduktor':
      return reproEdit(id);
    case 'dog':
    case 'pies':
      return piesEdit(id);
    default:
      return panelHome();
  }
};

export const getCreateRoute = (entityType) => {
  switch (entityType) {
    case 'kennel':
    case 'hodowla':
      return hodowlaCreate();
    case 'litter':
    case 'miot':
      return miotCreate();
    case 'stud':
    case 'reproduktor':
      return reproCreate();
    default:
      return panelHome();
  }
};
